import {makeGetPatientData} from 'main/factories/usecases/private/my-hospitalization/get-patient-data-factory';

export const getPatientData = async (signal: AbortSignal) => makeGetPatientData().get({signal});
